// Dependencies

import React, { Component } from 'react';

// Components

import Header from '../Header/Header';
import SocialMedia from '../SocialMedia/SocialMedia';
import Facebook from '../Facebook/Facebook';

// Images

import socialNetwork from '../images/social-networking.svg';
import facebookIcon from '../images/facebook.svg';

// Style

import './HomeSocial.css';

const HomeSocial = () => (
  <div className="home-social">
    <div className="home-social__social-media">
      <Header displayIcon='flex' heading="Follow Us Online" text="Check us out on social media. Visit our Facebook page, and don't forget to drop a like." icon={socialNetwork} />
      <SocialMedia />
    </div>
    <Facebook />

  </div>
);

export default HomeSocial;



// WEBPACK FOOTER //
// ./src/HomeSocial/HomeSocial.js